//import Contact from "../components/Contact.jsx";
import Layout from "../Layouts/Layout.jsx";

export default function Support() {
  return (
    <Layout title="Support">
      <div className="container w-full rounded-xl bg-white dark:bg-gray-800 shadow p-4 min-h-40">
        <iframe
            src="https://forms.fungistics.com/s/frjeb90wl47lg5hwssgjhon1?embed=true"
            width="100%"
            height="300px"
            frameBorder="0"
            className="mt-8"
          ></iframe>
      </div>
    </Layout>
  )
}



